import React, {Component} from "react";
import Dialog from "../../dialog/dialog";
import Svg from "../../svg/index";
import TipStyle from "./style";

//全局loading   大loading
class GlobalLoading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            left: -80,
            right: 0,
            leftFlag: false,
            rightFlag: false,
        };
    };

    /*
     * this.props.open
     * this.props.type
     *      submitting/loading   不需要传 btnText 和cancelBtnText
     *                           title    传的是标题说明  不传就不显示   如提交中  加载中(必填)
     *
     *      hint    cancelBtnText传的是取消按钮的说明 如返回 取消 默认取消
     *              btnText  传的是确认的按钮的说明  如提交 确认   默认确认
     *              title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleClose   是cancelBtnText对应按钮的方法 只在type为hint的时候传
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *
     *   fail       btnText  传的是确认的按钮的说明  如提交 确认   默认确认
     *              title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *   success     title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *
     *
     * */

    componentDidMount() {
        //this.initCanvas();
    };

    componentWillReceiveProps(newProps) {
        if (newProps.open && newProps.type == "loading") {
            this.initCanvas();
        }
    }

    initCanvas() {
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = canvas.parentNode.offsetWidth;
        canvas.height = canvas.parentNode.offsetHeight;
        //如果浏览器支持requestAnimFrame则使用requestAnimFrame否则使用setTimeout
        let requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();
        // 波浪大小
        var boHeight = canvas.height / 10;
        var posHeight = canvas.height / 1.2;
        //初始角度为0
        var step = 0;
        //定义三条不同波浪的颜色
        var lines = ["rgba(0,222,255, 0.2)",
            "rgba(157,192,249, 0.2)",
            "rgba(0,168,255, 0.2)"];

        function loop() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            step++;
            //画3个不同颜色的矩形
            for (var j = lines.length - 1; j >= 0; j--) {
                ctx.fillStyle = lines[j];
                //每个矩形的角度都不同，每个之间相差45度
                var angle = (step + j * 50) * Math.PI / 180;
                var deltaHeight = Math.sin(angle) * boHeight;
                var deltaHeightRight = Math.cos(angle) * boHeight;
                ctx.beginPath();
                ctx.moveTo(0, posHeight + deltaHeight);
                ctx.bezierCurveTo(canvas.width / 2, posHeight + deltaHeight - boHeight, canvas.width / 2, posHeight + deltaHeightRight - boHeight, canvas.width, posHeight + deltaHeightRight);
                ctx.lineTo(canvas.width, canvas.height);
                ctx.lineTo(0, canvas.height);
                ctx.lineTo(0, posHeight + deltaHeight);
                ctx.closePath();
                ctx.fill();
            }
            requestAnimFrame(loop);
        }

        loop();
    };

    render() {
        const contentStyle = {width: '31.25rem', background: "#fff", maxWidth: '120rem', borderRadius: '0.25rem',};
        const bodyStyle = {padding: '0', width: '100%'};
        //onRequestClose={this.props.handleFn}

        return (
            <Dialog open={this.props.open} contentStyle={contentStyle}
                    bodyStyle={bodyStyle}>
                <div style={Object.assign(this.props.open ? TipStyle.tipsBoxShow : TipStyle.tipsBoxHide)} ref="aa">
                    {/*图标*/}
                    <div style={this.props.type == "loading" ? null : TipStyle.svgBox}>
                        {(()=> {
                            switch (this.props.type) {
                                case 'success':
                                    return <Svg type="Correct" width="3.75rem" height="3.75rem" fill="#7FE57F"/>
                                case 'fail':
                                    return <Svg type="Error" width="3.75rem" height="3.75rem" fill="#ff6f72"/>
                                case 'hint':
                                    return <Svg type="Hint" width="3.75rem" height="3.75rem" fill="#ffbe62"/>
                                default:
                                    return null
                            }
                        })()}
                    </div>
                    <div
                        style={ this.props.type == 'loading' ? TipStyle.body1 : TipStyle.body}>
                        {this.props.title ? <p style={TipStyle.title}>{this.props.title}</p> : null}
                        {this.props.content ? <p style={TipStyle.content}>{this.props.content}</p> : null}
                    </div>

                    {this.props.type == 'fail' || this.props.type == 'success' ?
                        <div style={this.props.open ? TipStyle.buttonBoxOn : TipStyle.buttonBoxOff}
                             onClick={this.props.handleClose}>
                            <p style={TipStyle[this.props.type]}>{this.props.btnText ? this.props.btnText : '返回'}</p>
                        </div> : null}

                    {this.props.type == 'hint' ?
                        <div style={this.props.open ? TipStyle.buttonBoxOn : TipStyle.buttonBoxOff}>
                            {this.props.btnText ?
                                <p style={TipStyle.hintLeft } onClick={this.props.submitFn}>{this.props.btnText}</p>
                                : null
                            }
                            <p style={this.props.btnText ? TipStyle.hintRight : TipStyle.hint}
                               onClick={this.props.handleClose}>
                                {this.props.cancelBtnText ? this.props.cancelBtnText : '取消'}
                            </p>
                        </div> : null
                    }

                    <canvas id="canvas" style={
                        TipStyle.canvasBox
                        //Object.assign(
                        //this.props.type == 'loading' ? {display: "block"} : {display: "none"},
                        //TipStyle.canvasBox)
                    }></canvas>


                </div>
            </Dialog>

        )
    }
}


export default GlobalLoading;
